import {RouteRecordRaw} from "vue-router";

const Control: RouteRecordRaw[] = [{
    path: "control",
    name: "H5Control",
    component: () => import("@/page/h5/control/index.vue"),
}]

export default Control
